const isEmpty = (obj) => {
    for(let key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

const objectIsEmptyDeep = (obj) => {
    if (!obj){ return true;}
    return Object.keys(obj)
        .every(k => obj[k] ? !Object.keys(obj[k]).length : true)
}

const hasValue = (variable) => {
    return (variable !== null && variable !== undefined) && 
    ((typeof(variable) === 'string' && variable?.trim() !== '') || 
    typeof(variable) === 'number' || 
    typeof(variable) === 'boolean' || 
    (typeof(variable) === 'object' && 
        !(Array.isArray(variable) && variable.length === 0) &&
        !(Object.keys(variable).length === 0 && variable.constructor === Object)));
}

const arrayUniqueValue = (arr) => {
    return Array.from(new Set(arr))
}

const snakeCase = (str) => {
    return str
      ?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      ?.map(x => x.toLowerCase())
      ?.join('_');
}

const reverseSnakeCase = (str) => {
    return str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
}

/**
   * The function will format a value to the desired unit measurement format ie '94.7101' => '94.71%'.
   *
   * @param  item               The desired value to format.
   * @param  type               The type of desired measurement format for the return value ie '%'.
   * @param  doDisplaySymbol    Boolean to display/not display the symbol for the desired measurement format ie '%'. Defaults to false.
   * @return                    A string formatted to the desired number format e.g. '94.71%'.
   */
const formatNumber = (item, type, doDisplaySymbol = false) => {
    if (!(hasValue(item))) return item;

    const value = typeof(variable) === 'string' ? parseInt(item) : item;
    switch (type) {
        case '%': {
            const isOneHundred = value === 100;
            const finalValue = isOneHundred ? value.toFixed(0) : value.toFixed(2);
            return finalValue + `${doDisplaySymbol ? '%' : ''}`;
        };
        case '$': {
            const finalValue = value.toFixed(2);
            return `${doDisplaySymbol ? '$' : ''}` + finalValue;
        };
        case 'km': {
            const finalValue = value.toFixed(2);
            return finalValue + `${doDisplaySymbol ? 'km' : ''}`;
        };
        case '.': {
            const finalValue = value.toFixed(2);
            return finalValue;
        };
        // TODO: Add more types as needed
        default: return item;
    }
}


// https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2-lat1);  // deg2rad below
    var dLon = deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    return d;
  }
  
  function deg2rad(deg) {
    return deg * (Math.PI/180)
  }

const createPercentage = (min, max) => {
	if (!(min > 0) || !(max > 0)) return formatNumber(0, '%', true);

	return formatNumber(min / max * 100, '%', true);
}

export { hasValue, isEmpty, objectIsEmptyDeep, arrayUniqueValue, snakeCase, reverseSnakeCase, getDistanceFromLatLonInKm, formatNumber, createPercentage };